/*树结构*/


/*

*/
import { Box } from '@mui/material';
import { isUndefined } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './zTree.css'
import { InLoading } from '../../components';

const ZTree: React.FC = (props) => {
  const {data, OnItemClick, setCurCatalog , curCatalog, catalogType, prefix} = props;
  if (!data)
    return <InLoading></InLoading>;
  return (
    <Box className='ztree' style={{}}   > 
      <Box style={{}}>
        <MZTree >
          {data.map((item,i) => {
            if (item.type==='folder')
              return <ZTreeFolderItem prefix={prefix} catalogType={catalogType} key={i} curCatalog={curCatalog} OnItemClick={OnItemClick} item={item}></ZTreeFolderItem>;
            else
              return <ZTreeFileItem prefix={prefix} catalogType={catalogType} key={i} curCatalog={curCatalog} OnItemClick={OnItemClick} item={item}></ZTreeFileItem>;
          })}
                
        </MZTree>
      </Box> 
    </Box>
   
  );
};
const MZTree: React.FC = (props) => {
  const {children} = props;
  return (
    <Box>
      {children}
    </Box>
  );
};

const ZTreeFolderItem: React.FC = (props) => {
  const history = useHistory();

  const {item, hidden, OnItemClick, curCatalog,prefix,catalogType} = props;
  const [showHide, setShowHide] = useState(true);
  const [showFolder, setShowFolder] = useState(hidden);
  useEffect(() => {
    if (isUndefined(hidden))
      return;
    if (!hidden)
      return;
    setShowHide(hidden);
  }, [hidden]);
  return (
    <Box style={{paddingLeft:'20px'}}>
      <Box style={{cursor:'pointer',border:' solid  #bebebe', borderWidth:'0px 0px 1px 0px', padding:'15px 15px 15px 0px', display:(isUndefined(hidden)||!hidden ) ?'flex':'none', flexDirection:'row', width:'100%', alignItems:'center'}}>
        {/* <img onClick={() => {
          setShowHide(!showHide);
        }} src="/assets/folder.svg" style={{width:'70rpx', height:'70rpx'}}/>  */}
        <Box onClick={() => {
          setShowHide(!showHide);

            history.push('/'+prefix+'/product/'+item.id+'?catalogType='+catalogType);
        }} style={{paddingLeft:'20rpx', flexGrow:1, whiteSpace:'nowrap', textOverflow:'ellipsis', overflow:'hidden', fontSize:'16px',color:curCatalog?.id===item?.id?'red':'unset'}}>{item.cgName?.zh}</Box>
        {/* <img onClick={() => {
          OnItemClick(item);
        }} src="/assets/enter.svg" style={{width:'35rpx', height:'35rpx'}}/> */}
        <img onClick={() => {
          setShowHide(!showHide);
          
        }} src={showHide?'/images/right.svg':'/images/down.svg'} style={{width:'20px', height:'20px'}}/>
 
      </Box>
      {item.children&&item.children.map(((item1,i) => {
        if (item1.type==='folder')
          return <ZTreeFolderItem key={i} prefix={prefix} catalogType={catalogType}  curCatalog={curCatalog} OnItemClick={OnItemClick} hidden={showHide} item={item1}></ZTreeFolderItem>;
        else
          return <ZTreeFileItem key={i} prefix={prefix} catalogType={catalogType} curCatalog={curCatalog} OnItemClick={OnItemClick} hidden={showHide} item={item1}></ZTreeFileItem>;
      }))}
     
    </Box>
    


  );
};
const ZTreeFileItem: React.FC = (props) => {
  const history = useHistory();

  const {item, hidden, OnItemClick,curCatalog,prefix,catalogType} = props;
  const [showHide, setShowHide] = useState(true);
  useEffect(() => {
    if (isUndefined(hidden))
      return;
    if (!hidden)
      return;
    setShowHide(hidden);
  }, [hidden]);
  return (
    <Box style={{paddingLeft:'30px'}}>
      <Box style={{cursor:'pointer',border:' solid  #bebebe', borderWidth:'0px 0px 1px 0px', padding:' 15px  15px 15px 0px', display:(!hidden&&showHide)?'flex':'none', flexDirection:'row', width:'100%', alignItems:'center'}}>
        {/* <img src="/assets/product.svg" style={{width:'70rpx', height:'70rpx', paddingLeft:'50rpx'}}/> */}
        <Box onClick={() => {
          // setShowHide(!showHide);

            history.push('/'+prefix+'/productDetail/'+item.id+'?catalogType='+catalogType);
        }}  style={{fontSize:'16px', paddingLeft:'20rpx', flexGrow:1, whiteSpace:'nowrap', textOverflow:'ellipsis', overflow:'hidden'}}>{item.details?.descriptionShort?.zh}</Box>
        {/* <img onClick={() => {
          OnItemClick(item);
        }} src="/images/right.svg" style={{width:'20px', height:'20px'}}/> */}
      </Box>
    </Box>
    


  );
};
export default ZTree;